(function () {
  var INTERVAL = 100;
  var TIMEOUT = 10000;

  function bind() {
    var selects = document.querySelectorAll('.kaching-bundles-option');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.getAttribute('data-bound')) continue;
      select.setAttribute('data-bound', '1');

      select.addEventListener('change', function (e) {
        var value = e.target.value;
        if (!value) return;

        var target = document.querySelector(
          '[data-custom-color="' + value + '"]'
        );

        if (target) target.click();
      });
    }
  }

  var start = Date.now();
  var timer = setInterval(function () {
    if (document.querySelector('.kaching-bundles-option')) {
      console.log('found, clear');
      clearInterval(timer);
      bind();
      return;
    }

    if (Date.now() - start > TIMEOUT) {
      console.log('not found, clear');
      clearInterval(timer);
    }
    console.log('retry');
  }, INTERVAL);
})();
